import script from "./AccordionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionCard.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionCard.vue?vue&type=style&index=0&id=2276e51a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2276e51a"]])

export default __exports__